module.exports = __webpack_public_path__ + "img/background.bc331c9a.jpg";